import { SCHEDULER_LABEL_CLASS, SCHEDULER_SELECT_CLASS } from './schedulerFieldClasses';

export interface ScheduleDateFieldsProps {
  viewKey: string;
  startDate: string;
  endDate: string;
  noEndDate: boolean;
  disabled: boolean;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onNoEndDateChange: (noEndDate: boolean) => void;
}

/** The first send date, and the last one unless the schedule has no end date. */
export const ScheduleDateFields = ({
  viewKey,
  startDate,
  endDate,
  noEndDate,
  disabled,
  onStartDateChange,
  onEndDateChange,
  onNoEndDateChange
}: ScheduleDateFieldsProps) => {
  return (
    <div className="flex gap-4 mb-3 flex-wrap">
      <div>
        <label
          htmlFor={`start-date-${viewKey}`}
          className={SCHEDULER_LABEL_CLASS}>
          Start Date
        </label>
        <input
          id={`start-date-${viewKey}`}
          type="date"
          className={`${SCHEDULER_SELECT_CLASS} pr-2`}
          value={startDate}
          disabled={disabled}
          onChange={(e) => onStartDateChange(e.target.value)}
        />
      </div>
      <div>
        <label
          htmlFor={`end-date-${viewKey}`}
          className={SCHEDULER_LABEL_CLASS}>
          End Date
        </label>
        <input
          id={`end-date-${viewKey}`}
          type="date"
          className={`${SCHEDULER_SELECT_CLASS} pr-2`}
          value={endDate}
          disabled={disabled || noEndDate}
          onChange={(e) => onEndDateChange(e.target.value)}
        />
        <label
          htmlFor={`no-end-date-${viewKey}`}
          className="flex items-center gap-1 mt-1 cursor-pointer text-xs text-gray-500">
          <input
            id={`no-end-date-${viewKey}`}
            type="checkbox"
            checked={noEndDate}
            disabled={disabled}
            onChange={(e) => {
              onNoEndDateChange(e.target.checked);
              if (e.target.checked) onEndDateChange('');
            }}
          />
          No End Date
        </label>
      </div>
    </div>
  );
};
